module.exports = __webpack_public_path__ + "static/media/DATAWEB.15a73d4b.jpg";